import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { QueryResult, Transaction } from '@app/shared';

import { Template } from './template';
import { PurchaseRequisition } from "@app/procurement/purchase-requisition/purchase-req";

@Injectable()
export class TemplateDataService {

  constructor (private http: HttpClient) { }

  getTemplate(txnType: Transaction): Observable<QueryResult> {
    let url: string;
    if (txnType == Transaction.ExpenseReport) {
      url = `/finance/expense-reports/templates/self`;
    } else if (txnType == Transaction.PurchaseRequisition) {
      url = `/procurement/purchase-requisitions/templates`;
    }
    else if (txnType == Transaction.JobRequisition) {
      url = '/recruiting/job-reqs/templates/search';
    } else if (txnType == Transaction.SalesOrder) {
      url = '/order-management/sales-order/templates';
    }
    return this.http.get<QueryResult>(url);
  }

  saveTemplate(txnType: Transaction, template: Template): Observable<any> {
    let url: string;
    if (txnType == Transaction.ExpenseReport) {
      url = '/finance/expense-reports/templates';
    } else if (txnType == Transaction.PurchaseRequisition) {
      url = '/procurement/purchase-requisitions/templates';
    } else if (txnType == Transaction.JobRequisition) {
      url = '/recruiting/job-reqs/templates';
    } else if (txnType == Transaction.SalesOrder) {
      url = '/order-management/sales-order/templates';

    }
    return this.http.post(url, template);
  }

  deleteTemplate(txnType: Transaction, templateId: number): Observable<any> {
    let url: string;
    if (txnType == Transaction.ExpenseReport) {
      url = `/finance/expense-reports/templates/${templateId}`;
    } else if (txnType == Transaction.PurchaseRequisition) {
      url = `/procurement/purchase-requisitions/templates/${templateId}`;
    } else if (txnType == Transaction.JobRequisition) {
      url = `/recruiting/job-reqs/templates/${templateId}`;
    } else if (txnType == Transaction.SalesOrder) {
      url = `/order-management/sales-order/templates/${templateId}`;

    }
    return this.http.delete(url);
  }

  getPurchaseReqTemplateByPRId(purchaseReqId: number) {
    let url: string = '/procurement/purchase-requisitions/templates/pr-id/' + purchaseReqId;
    return this.http.get<PurchaseRequisition>(url);
  }
}
